import * as Sentry from "@sentry/react";
import React from "react";

import { SlicerErrorCard } from "./SlicerErrorCard";

interface SlicerErrorBoundaryProps {
  slicerName: string;
  onFixBlock?: (blockId: string, errorMessage: string) => void;
  children: React.ReactNode;
}

interface SlicerErrorBoundaryState {
  hasError: boolean;
  errorMessage: string;
}

export class SlicerErrorBoundary extends React.Component<
  SlicerErrorBoundaryProps,
  SlicerErrorBoundaryState
> {
  constructor(props: SlicerErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, errorMessage: "" };
  }

  static getDerivedStateFromError(error: Error): SlicerErrorBoundaryState {
    return { hasError: true, errorMessage: error.message };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    Sentry.captureException(error, {
      tags: { feature: "web_dashboard", errorType: "slicer_crash" },
      extra: {
        slicerName: this.props.slicerName,
        componentStack: errorInfo.componentStack,
      },
    });
  }

  render() {
    if (this.state.hasError) {
      const { slicerName, onFixBlock } = this.props;
      return (
        <SlicerErrorCard
          label={slicerName}
          slicerName={slicerName}
          errorMessage={this.state.errorMessage}
          onFixBlock={onFixBlock}
        />
      );
    }

    return this.props.children;
  }
}
